// Utility to render email recipients as a string
export const renderRecipient = (recipients?: string[] | string) => {
  if (!recipients || (Array.isArray(recipients) && recipients.length === 0)) {
    return '';
  }
  return Array.isArray(recipients) ? recipients.join(', ') : recipients;
};

// Utility to disable href links from email templates and replace with plain text
export function removeHrefKeepText(html: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  doc.querySelectorAll('a').forEach(a => {
    const textNode = document.createTextNode(a.textContent ?? '');
    a.replaceWith(textNode);
  });

  return doc.body.innerHTML;
}
